<script>
    export let header = '';
    export let text = '';
</script>

<div class="central">
    <slot name="beforeText"></slot>
    <div class="container">
        <h2 class="central__h2">{header}</h2>
        <p class="central__p">{text}</p>
    </div>
    <slot name="afterText"></slot>
</div>

<style lang="postcss">
    .central{
        text-align: center;
    }
    .central__h2{
        font-size: 1.25rem;
        margin: * auto;
        max-width: 24.375rem;
    }
    .central__p{
        margin: 16px auto 18px;
        max-width: 30.25rem;
    }
    @media (min-width:992px){
        .central__h2{
            font-size: 1.67rem;
        }
        .central__p{
            font-size: 0.88rem;
        }
    }
</style>